import { ResultComponent } from "./result.component";

export const Result = ResultComponent;